// import { ChangeDetectionStrategy } from '@angular/compiler/src/compiler_facade_interface';
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="showLoading" class="content overlay">
      <div *ngIf="loaderName == 'loader1'" class="imgParent">
        <section class="load">
          <div class="loading loading06">
            <span data-text="R">R</span>
            <span data-text="E">E</span>
            <span data-text="C">C</span>
            <span data-text="O">O</span>
            <span data-text="N">N</span>
          </div>
        </section>
      </div>
      <div *ngIf="loaderName == 'loader2'" class="imgParent">
        <div class="card">
          <div class="card-body">
            <img
              class="imgGif"
              src=" /home/caratred/CaratRed Projects/Bonvoy_wash_frontend-1/src/assets/gif/loader.gif"
            />

            <div class="loading_msg">
              <p class="title1">Take a break and relax</p>
              <p class="title2">{{ this.message }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ng-content></ng-content>
  `,
  styles: [
    `
      /* Loader 1 */
      .loader-1 {
        height: 32px;
        width: 32px;
        -webkit-animation: loader-1-1 4.8s linear infinite;
        animation: loader-1-1 4.8s linear infinite;
      }
      .imgParent {
        /* display: flex;
  justify-content: center;
  align-items : center; */
      }
      .imgGif {
        width: 273px;
        text-align: center;
      }
      .imgGif2 {
        width: 65px;
        height: 45px;
        text-align: center;
      }
      @-webkit-keyframes loader-1-1 {
        0% {
          -webkit-transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(360deg);
        }
      }
      @keyframes loader-1-1 {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
      .loader-1 span {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        height: 32px;
        width: 32px;
        clip: rect(0, 32px, 32px, 16px);
        -webkit-animation: loader-1-2 1.2s linear infinite;
        animation: loader-1-2 1.2s linear infinite;
      }
      @-webkit-keyframes loader-1-2 {
        0% {
          -webkit-transform: rotate(0deg);
        }
        100% {
          -webkit-transform: rotate(220deg);
        }
      }
      @keyframes loader-1-2 {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(220deg);
        }
      }
      .loader-1 span::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        height: 32px;
        width: 32px;
        clip: rect(0, 32px, 32px, 16px);
        border: 3px solid #fff;
        border-radius: 50%;
        -webkit-animation: loader-1-3 1.2s cubic-bezier(0.77, 0, 0.175, 1)
          infinite;
        animation: loader-1-3 1.2s cubic-bezier(0.77, 0, 0.175, 1) infinite;
      }
      @-webkit-keyframes loader-1-3 {
        0% {
          -webkit-transform: rotate(-140deg);
        }
        50% {
          -webkit-transform: rotate(-160deg);
        }
        100% {
          -webkit-transform: rotate(140deg);
        }
      }
      @keyframes loader-1-3 {
        0% {
          transform: rotate(-140deg);
        }
        50% {
          transform: rotate(-160deg);
        }
        100% {
          transform: rotate(140deg);
        }
      }

      .card {
        width: 400px;
        height: 400px;
        border-radius: 42px;
      }
      .loading_msg {
        .title1 {
          font-size: 24px;
          font-weight: bold;
          margin: 0px;
        }
        .title2 {
          margin-top: 11px;
          /* color:black !important; */
          font-weight: bold;
        }
      }
      .overlay {
        text-align: center;
        height: 100%;
        width: 100%;
        position: fixed;
        z-index: 10000;
        top: 0;
        left: 0;
        // background-color: rgba(0, 0, 0, 0.5);
        // background-color:white;
        overflow-x: hidden;
        transition: 0.5s;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .load {
        width: 100vw;
        height: 100vh;
      }

      .loading {
        font-size: 24px;
        font-family: 'Montserrat', sans-serif;
        font-weight: 800;
        text-align: center;
        span {
          display: inline-block;
          margin: 0 -0.05em;
        }
        letter-spacing: 5px;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(to bottom right, black, transparent);
      }

      .loading06 {
        span {
          position: relative;
          color: #fff;
          // color:#38444F;
          &::after {
            position: absolute;
            top: 0;
            left: 0;
            content: attr(data-text);
            // color: #fff;
          color: #38444F;
            opacity: 0;
            transform: rotateY(-90deg);
            animation: loading06 4s infinite alternate;
          }
          @for $i from 1 through 6 {
            &:nth-child(#{$i + 1})::after {
              animation-delay: #{$i * 0.2}s;
            }
          }
        }
      }
      @keyframes loading06 {
        0%,
        75%,
        100% {
          transform: rotateY(0deg);
          opacity: 0;
        }
        25%,
        50% {
          transform: rotateY(0deg);
          opacity: 1;
        }
      }

      .wrapper {
        position: absolute;
        display: flex;
        align-items: center;
        gap: 5px;
        top: 55%;
        left: 46%;
      }
      .ball {
        width: 6px;
        height: 6px;
        background: linear-gradient(to right, white, transparent);
        border-radius: 50%;
        animation: slide 4s ease-in-out infinite alternate;
        opacity: 1;
      }
      .ball:nth-child(1) {
        animation-delay: 100ms;
      }
      .ball:nth-child(2) {
        animation-delay: 200ms;
      }
      .ball:nth-child(3) {
        animation-delay: 300ms;
      }
      .ball:nth-child(4) {
        animation-delay: 400ms;
      }
      .ball:nth-child(5) {
        animation-delay: 500ms;
      }
      .ball:nth-child(6) {
        animation-delay: 600ms;
      }
      .ball:nth-child(7) {
        animation-delay: 700ms;
      }
      .ball:nth-child(8) {
        animation-delay: 800ms;
      }
      .ball:nth-child(9) {
        animation-delay: 900ms;
      }

      @keyframes slide {
        50% {
          opacity: 1;
          transform: translateY(-15px);
        }
        100% {
          opacity: 0;
          transform: translateY(0px);
        }
      }
      .loader {
        height: 4px;
        width: 130px;
        --c: no-repeat linear-gradient(#6100ee 0 0);
        background: var(--c), var(--c), #d7b8fc;
        background-size: 60% 100%;
        animation: l16 3s infinite;
      }
      @keyframes l16 {
        0% {
          background-position: -150% 0, -150% 0;
        }
        66% {
          background-position: 250% 0, -150% 0;
        }
        100% {
          background-position: 250% 0, 250% 0;
        }
      }
    `,
  ],
})
export class LoaderComponent implements OnInit {
  showLoading = false;
  message: any;
  loaderName: any;
  constructor(
    private loaderService: LoaderService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.message = '';
    this.loaderService.getLoaderStats().subscribe((res) => {
      this.showLoading = res.status;
      this.loaderName = res.loaderName;
      this.cdr.detectChanges();
    });
    this.loaderService.getLoaderMessageStatus().subscribe((result) => {
      if (result) {
        this.message = result;
      } else {
        this.message = 'Processing...';
      }
    });
  }
}

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  public loader: BehaviorSubject<any> = new BehaviorSubject<any>({
    status: false,
    loaderName: 'loader1',
  });
  public loaderMessage: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  constructor() { }
  showLoader(loaderName: any) {
    let obj = {
      status: true,
      loaderName: loaderName,
    };
    this.loader.next(obj);
  }
  hideLoader() {
    let obj = {
      status: false,
      loaderName: '',
    };
    this.loader.next(obj);
  }
  getLoaderStats() {
    return this.loader.asObservable();
  }

  setLoaderMessage(message: any) {
    this.loaderMessage.next(message);
  }
  getLoaderMessageStatus() {
    return this.loaderMessage.asObservable();
  }
}
